import { Link } from "react-router-dom";
import "./SiteFooter.css";

type InformationPage = "manifesto" | "privacy" | "terms";

export default function SiteFooter({ currentPage }: { currentPage?: InformationPage }) {
  return (
    <footer className="bs-site-footer">
      <div className="bs-site-footer-inner">
        <small className="bs-site-footer-copy">&copy; Blackspace {new Date().getFullYear()}</small>
        <nav className="bs-site-footer-links" aria-label="Blackspace information">
          <Link to="/manifesto" aria-current={currentPage === "manifesto" ? "page" : undefined}>Manifesto</Link>
          <Link to="/privacy" aria-current={currentPage === "privacy" ? "page" : undefined}>Privacy</Link>
          <Link to="/terms" aria-current={currentPage === "terms" ? "page" : undefined}>Terms</Link>
        </nav>
      </div>
    </footer>
  );
}
